import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlQueryService} from '../../common/url-query/url-query.service';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class AlarmsApiService {

  readonly activeAlarmsUrl: string = 'alarms/active';
  readonly historyAlarmsUrl: string = 'alarms/history';
  readonly additionalInfoAlarmsUrl: string = 'alarms/additionalInfo';
  readonly activeAlarmsCountUrl: string = `${this.activeAlarmsUrl}/count`;

  constructor(private http: HttpClient) { }

  private getAlarms(alarmUrlPath: string, params: object): Observable<any> {
    const url = UrlQueryService.addQueryParameters(alarmUrlPath, params);
    return this.http.get(url);
  }

  public getActiveAlarms(params: object = {}): Observable<any> {
    this.setAcknowledgedFilter(params);
    return this.getAlarms(this.activeAlarmsUrl, params);
  }

  public getHistoryAlarms(params: object = {}): Observable<any> {
    return this.getAlarms(this.historyAlarmsUrl, params);
  }

  public getActiveAlarmsCount(): Observable<any> {
    return this.http.get(this.activeAlarmsCountUrl);
  }

  public editActiveAlarmsAsAcknowledge(alarmsIds: number[]): Observable<any> {
    const requestBody = {
      isAcknowledged: true
    };

    const params = {
      filter: {
        id: {
          value: alarmsIds,
          operator: '='
        }
      }
    };

    return this.updateActiveAlarms(alarmsIds, requestBody, params);
  }

  public updateActiveAlarms(alarmsIds: number[], requestBody: object, params: object = {}): Observable<any>{
    const url = UrlQueryService.addQueryParameters(this.activeAlarmsUrl, params);

    return this.http.put(url, requestBody);
  }

  public getAdditionalInfoAlarms(): Observable<any> {
    return this.http.get(this.additionalInfoAlarmsUrl);
  }

  public editAdditionalInfoAlarms(additionalInfo, additionalInfoId): Observable<any> {
    return this.http.put(`${this.additionalInfoAlarmsUrl}/${additionalInfoId}`, additionalInfo);
  }

  public testAdditionalInfoAlarms(additionalInfo): Observable<any> {
    return this.http.put(`${this.additionalInfoAlarmsUrl}/test`, additionalInfo);
  }

  private setAcknowledgedFilter(params): void {
    const isAcknowledgedFilter = {
      value: '0',
      operator: '='
    };

    if (params.filter) {
      if (_.isNil(params.isAcknowledged)) {
        params.filter.isAcknowledged = isAcknowledgedFilter;
      }
    } else {
      params.filter = {
        isAcknowledged: isAcknowledgedFilter
      };
    }
  }

}
